// ----------------------------------------------------------------------

export default function Badge(theme?:React.CSSProperties | any) {
  return {
    MuiBadge: {
      styleOverrides: {
        dot: {
          width: 10,
          height: 10,
          borderRadius: '50%',
        },
      },
    },
  };
}
